import { LOGIN_REQUEST_FAILED, LOGIN_REQUEST_PENDING, LOGIN_REQUEST_SUCCESS, LOGOUT } from "../actionType"

const InitialState={
    loading:false,
    error:false,
    isAuth:false,
    token:null,
    user:null
}

export default function AuthReducer(state=InitialState,action){
    switch(action.type){
        case LOGIN_REQUEST_SUCCESS:
            return{
                ...state,isAuth:true,token:action.payload.data.token, user:action.payload.data.user
            }
        case LOGIN_REQUEST_PENDING:
            return{
                ...state,loading:true
            }
        case LOGIN_REQUEST_FAILED:
            return{
                ...state,loading:false,error:true
            }
        case LOGOUT:
            return{
                ...state,isAuth:false,token:null,user:null
            }
        default:
            return state
    }
}